export enum ProductType {
  UNKNOWN = 'UNKNOWN',
  RAPICREDIT = 'RAPICREDIT',
  RAPIPLAZO = 'RAPIPLAZO',
  RAPISUELDO = 'RAPISUELDO',
  ALIANZA = 'ALIANZA',
  RP = 'RP',
  RF = 'RF',
  RFYA = 'RFYA',
  RETRP = 'RETRP',
  RETRF = 'RETRF',
}

export enum PRODUCT_ID_ENUMERATION {
  RF = '1',
  RP = '2',
}
